// src/pages/Profile.js
import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const { user, token, logout } = useAuth();
  const [history, setHistory] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return; // don't call API if logged out

    axios
      .get('https://flightiq.app/authapi/profile_data.php', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHistory(res.data.history || []);
      })
      .catch((err) => console.error(err));
  }, [token]);

  // 👇 Redirect if not logged in
  useEffect(() => {
    if (!user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (!user) {
    return null; // nothing while redirecting
  }

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, px: 2 }}>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Your Profile
        </Typography>
        <Typography>Name: {user.username}</Typography>
        <Typography>Email: {user.email}</Typography>
        <Button
          variant="contained"
          onClick={() => {
            logout();
            navigate('/'); // also push home right after logout
          }}
          sx={{ mt: 2 }}
        >
          Logout
        </Button>
      </Paper>

      <Paper elevation={2} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Transaction History
        </Typography>
        {history.length ? (
          history.map((item, idx) => (
            <Box key={idx} sx={{ mb: 1 }}>
              <Typography>{JSON.stringify(item)}</Typography>
            </Box>
          ))
        ) : (
          <Typography>No history found.</Typography>
        )}
      </Paper>
    </Box>
  );
}
